import { white } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var inputText = {
    '& .ag-cell-inline-editing': {
        border: 'none',
        borderRadius: 0,
        boxShadow: 'none',
        height: '100%',
        padding: 0,
        '& input[class^=ag-][type=text]': {
            backgroundColor: white,
            border: 'none',
            borderRadius: 0,
            height: '100%',
            paddingBlock: 0,
            paddingInline: rem(12),
            '&:focus': {
                border: "".concat(rem(2), " solid var(--yds-ag-cell-edit-border-color)"),
            },
        },
    },
    '& .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected).ag-cell-inline-editing': {
        border: 'none',
    },
    '& .ag-ltr .ag-cell.ag-cell-inline-editing': {
        borderRightWidth: 0,
    },
};
